import AXIS_LOGO from "../assets/icon/AXIS_LOGO.svg";
import SAFE_SHIELD from "../assets/icon/SAFE_SHIELD.svg";
import ONBOARDING_IMAGE from "../assets/img/ONBOARDING.svg";
import CROSS_FILLED_RED_CIRCLE from "../assets/icon/CROSS_FILLED_RED_CIRCLE.svg";
import PROTECTION from "../assets/icon/PROTECTION.svg";
import CHILD_EDUCATION from "../assets/icon/CHILD_EDUCATION.svg";
import CHILD_WEDDING from "../assets/icon/CHILD_WEDDING.svg";
import INVESTMENT from "../assets/icon/INVESTMENT.svg";
import RETIREMENT from "../assets/icon/RETIREMENT.svg";
import QUESTION_MARK from "../assets/icon/QUESTION_MARK.svg";
import TRASH from "../assets/icon/TRASH.svg";
import PLUS from "../assets/icon/PLUS.svg";
import EDIT from "../assets/icon/EDIT.svg";
import LUXURY from "../assets/icon/LUXURY.svg";
import MINIMALIST from "../assets/icon/MINIMALIST.svg";
import COMFORT from "../assets/icon/COMFORT.svg";
import FINANCIAL_DETAIL from "../assets/img/FINANCIAL_DETAIL.svg";
import FINANCIAL_SHADOW from "../assets/img/FINANCIAL_SHADOW.svg";
import WHITE_ELLIPSE from "../assets/icon/WHITE_ELLIPSE.svg";
import ARROW_LONG from "../assets/icon/ARROW_LONG.svg";
import BACK_ARROW_WHITE from "../assets/icon/BACK_ARROW_WHITE.svg";
import CROSS_RED from "../assets/icon/CROSS_RED.svg";

export const ImageLibrary = {
  AXIS_LOGO: AXIS_LOGO,
  SAFE_SHIELD: SAFE_SHIELD,
  ONBOARDING_IMAGE: ONBOARDING_IMAGE,
  CROSS_FILLED_RED_CIRCLE: CROSS_FILLED_RED_CIRCLE,
  PROTECTION: PROTECTION,
  CHILD_EDUCATION: CHILD_EDUCATION,
  CHILD_WEDDING: CHILD_WEDDING,
  INVESTMENT: INVESTMENT,
  RETIREMENT: RETIREMENT,
  QUESTION_MARK: QUESTION_MARK,
  TRASH: TRASH,
  PLUS: PLUS,
  EDIT: EDIT,
  LUXURY: LUXURY,
  MINIMALIST: MINIMALIST,
  COMFORT: COMFORT,
  FINANCIAL_DETAIL: FINANCIAL_DETAIL,
  FINANCIAL_SHADOW: FINANCIAL_SHADOW,
  WHITE_ELLIPSE: WHITE_ELLIPSE,
  ARROW_LONG: ARROW_LONG,
  BACK_ARROW_WHITE: BACK_ARROW_WHITE,
  CROSS_RED: CROSS_RED,
};
